<template>
    <div>
        <el-dialog
          width="500px"
          :center="true"
          :visible.sync="sendCodeDialogVisible"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :before-close="onCloseDialog"
          @close="onCloseDialog"
          title="请输入验证码"
        >
          <div class="dialog-sendCode">
            <img
            :src="imgSrc"
            class="codeimg fr"
            style="margin-left: 10px"
            width="140"
            height="40"
            alt
            @click="refreshpic"
            />
            <el-form :model="sendCodeForm" ref="sendCodeForm" class="demo-dynamic" @submit.native.prevent>
              <el-form-item
                prop="code"
                :rules="[
                  { required: true, message: '请输入验证码', trigger: 'blur' }
                ]"
               >
                 <el-input v-model="sendCodeForm.code" placeholder="请输入验证码" maxlength="4"></el-input>
               </el-form-item>
            
            </el-form>
            
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="default" @click="onCloseDialog">取 消</el-button>
            <el-button type="primary" @click="onConfirmDialog" :disabled="!sendCodeForm.code">确定</el-button>
          </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
  props: {
    sendCodeDialogVisible: { type: Boolean,default() {return false;}}
  },
  data() {
    return {
      imgSrc:"",
      imgToken:"",
      sendCodeForm:{
        code:""
      }
    };
  },
  mounted() {
      this.refreshpic();
  },
  computed: {
    propsdialogVisible() { 
        return this.sendCodeDialogVisible
    }
  },
  watch: {
    propsdialogVisible(newV,oldV) {
        if(newV){
          this.refreshpic();
          if(this.$refs['sendCodeForm']){
            this.$refs['sendCodeForm'].resetFields();
          }
        }
    }
  },
  methods: {
    // 关闭弹框
    onCloseDialog() {
      this.$emit("close-dialog");
    },
    //点击确定按钮
    onConfirmDialog(){
      this.$emit("confirm-dialog",{captchaToken:this.imgToken,captchaAnswer:this.sendCodeForm.code});
    },
    //获取图片验证码
    refreshpic: function() {
      // var that = this;
      var sj = Math.ceil(Math.random() * 100000);
      this.$http.post(`/api/web/uuc/code`).then(json => {
        this.imgSrc = json.data.captcha_image;
        this.imgToken = json.data.captcha_token;
      });
    },

  }
 };
</script>
<style lang="scss">
.dialog-sendCode{
    text-align: center;
    img{
        margin-bottom: 30px;
    }
}
</style>